var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBgDesktop = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 1168,
  height: 1263,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: "dd-privacy-hidden"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M766.985 91.189c110.005 48.844 10.131 154.982 178.994 231.26 124.441 56.212 85.181 367.092-55.341 414.178-110.53 37.038-233.883-154.851-400.191-188.555-97.001-19.659-88.783-276.783.413-309.333 63.017-22.995 166.121-196.395 276.125-147.55Z",
  fill: "#81B1B0",
  fillOpacity: 0.3
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M128.488 795.508c72.921-100.124 137.566 3.155 250.633-150.434 83.323-113.185 344.6 43.619 346.648 180.518C727.38 933.276 494.841 752.329 419.5 907c-43.943 90.214-185.185 236.56-279.481 158.8-46.678-38.5-84.452-170.168-11.531-270.292Z",
  fill: "#81B1B0",
  fillOpacity: 0.3
})));
export default SvgBgDesktop;